import { Box, Typography } from '@mui/material'
import { SideContent } from 'components-shared'
import { useTranslation } from 'react-i18next'
import CardPreview, { CardBlockInfo, CardBody, CardHeader } from 'packages/ui/CardPreview'
import { useNavigate, useParams } from 'react-router-dom'
import { formatBitrate } from './utils'
import { useIPTV } from './use-iptv'
import { IPTVChannel } from './types'

interface HeaderProps {
  channel: IPTVChannel
}

interface BodyProps {
  channel: IPTVChannel
}

const Header: React.FC<HeaderProps> = ({ channel }) => {
  return (
    <CardHeader>
      <Box sx={{ pt: 4 }}>
        <Typography>{channel.name || '_'}</Typography>
      </Box>
      <Box sx={{ pb: 4 }}>
        <img
          src={channel.logo || '_'}
          alt={channel.name}
          style={{
            width: 100,
            height: 100,
            objectFit: 'contain'
          }}
        />
      </Box>
    </CardHeader>
  )
}

const Body: React.FC<BodyProps> = ({ channel }) => {
  const { t } = useTranslation()
  
  return (
    <CardBody grid>
      <CardBlockInfo
        title={t('iptv.card.channel')}
        subtitle={channel.position as number || '_'}
      />
      <CardBlockInfo
        title={t('iptv.card.ip_address')}
        subtitle={channel.ip_address || '_'}
      />
      <CardBlockInfo
        title={t('iptv.card.port')}
        subtitle={channel.port || '_'}
      />
      <CardBlockInfo
        title={t('iptv.card.bitrate')}
        subtitle={formatBitrate(channel.bitrate) || '_'}
      />
      <CardBlockInfo
        title={t('iptv.card.wisi_input')}
        subtitle={channel.wisi_input_name || '_'}
      />
      <CardBlockInfo
        title={t('iptv.card.wisi_module')}
        subtitle={channel.module || '_'}
      />
    </CardBody>
  )
}

const Card = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { id } = useParams()
  const { channels, error } = useIPTV()
  
  const channel = channels.find(c => c.id?.toString() === id)
  
  if (!channel) return null
  
  return (
    <SideContent style={{ marginTop: 0 }}>
      <CardPreview
        title={t('iptv.card.title')}
        onClose={() => navigate({ pathname: '..' })}
        error={error}
      >
        <Header channel={channel} />
        <Body channel={channel} />
      </CardPreview>
    </SideContent>
  )
}

export default Card
